import { render, staticRenderFns } from "./flatSidebar.vue?vue&type=template&id=8da45e62&"
import script from "./flatSidebar.vue?vue&type=script&lang=js&"
export * from "./flatSidebar.vue?vue&type=script&lang=js&"
import style0 from "./flatSidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports